import React from 'react'
import { Toaster } from '@/common/components/ui/toaster.tsx'
import { AppLayout } from '@/common/layouts/AppLayout.tsx'
import { Outlet } from 'react-router'

export const App: React.FC = () => {
  return (
    <div className="w-full h-full">
      <AppLayout>
        <Outlet />
      </AppLayout>
      <Toaster />
    </div>
  )
}
